import Axios from "axios";
import { getApiConfig } from "@/config/domainConfig";

Axios.withCredentials = true;

// Obtenir la configuration API selon le domaine
const apiConfig = getApiConfig();

const authClient = Axios.create({
	baseURL: apiConfig.baseURL,
	json: true,
});

export default authClient;
